import { useState, useEffect } from "react";
import { Box, Button, CardMedia, Card, TextField } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeCategory } from "./UseHomeCategory";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditLandItem(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const location = useLocation();
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { validateItem, updateCategoryItem } = UseHomeCategory();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    categoryID: undefined,
    url: undefined,
    title: "بدون عنوان",
    rowIndex: undefined,
    width: undefined,
    height: undefined,
  });

  const [imgState, setImgState] = useState({
    imageFile: undefined,
    imageUrl: undefined,
    iconeFile: undefined,
    iconeUrl: undefined,
  });

  useEffect(() => {
    if (location.state.row) {
      setState({
        id: location.state.row.id,
        categoryID: location.state.row.categoryID,
        url: location.state.row.url,
        title: location.state.row.title
          ? location.state.row.title
          : "بدون عنوان",
        rowIndex: location.state.row.rowIndex,
        height: location.state.row.height,
        width: location.state.row.width,
      });
      setImgState({
        imageFile: undefined,
        imageUrl: location.state.row.image ? location.state.row.image : "",
        iconeFile: undefined,
        iconeUrl: location.state.row.icon ? location.state.row.icon : "",
      });
    }
  }, [location.state.row]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeIcone = (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file[0]);
    img.onload = () => {
      setState({ ...state, width: img.width, height: img.height });
    };
    setImgState({
      ...imgState,
      iconeFile: file[0],
      iconeUrl: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      imageFile: file[0],
      imageUrl: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/CategoriesManage",
            CategoryID: location.state.CategoryID && location.state.CategoryID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: "ویرایش آیتم",
            url: "/CategoriesManage/editItem",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.url ? state.url : ""}
              error={errorState.url}
              label="آدرس"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, url: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn="span 12"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeIcone(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "80px", height: "auto", mr: 5 }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.iconeUrl
                          ? imgState.iconeUrl
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
            <TextField
              fullWidth
              value={state.width ? state.width : ""}
              error={errorState.width}
              label="عرض"
              sx={{
                input: {
                  direction: "rtl",
                },
                width: isSmall ? "50%" : "15%",
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, width: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              fullWidth
              value={state.height ? state.height : ""}
              error={errorState.height}
              label="طول"
              sx={{
                input: {
                  direction: "rtl",
                },
                width: isSmall ? "50%" : "15%",
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, height: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "170px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.imageUrl
                          ? imgState.imageUrl
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => {
                if (validateItem(state, setErrorState) == 200) {
                  setProgress(true);
                  updateCategoryItem(
                    state,
                    imgState.imageFile,
                    imgState.iconeFile,
                    (calback) => {
                      navigate("/CategoriesManage", {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      });
                    }
                  );
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/CategoriesManage", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      </Box>
    </Detail>
  );
}
